import { doc, updateDoc } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { uploadMedia } from "./uploadMedia";
import deleteImage from "./deleteImage";

async function updateTakeaway({ orgId, updateData, oldImageUrl }) {
  const db = getFirestore();
  const orgRef = doc(db, "Organizations", orgId);

  try {
    if (
      updateData.coverUrl &&
      ((oldImageUrl && oldImageUrl !== updateData.coverUrl) || !oldImageUrl)
    ) {
      const imageUrl = await uploadMedia(
        updateData.coverUrl,
        `shops/${orgId}/${new Date().getTime()}`,
      );
      if (oldImageUrl) {
        await deleteImage(oldImageUrl);
      }

      updateData.coverUrl = imageUrl;
    }

    await updateDoc(orgRef, updateData);
  } catch (error) {
    console.error("Erreur lors de la mise à jour de l'organisation :", error);
    throw error;
  }
}

export default updateTakeaway;
